// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"161":"62dac052","551":"a885732b","906":"6da95a2e"}[chunkId] + ".chunk.css";
};